export class refundApprove {
    refundDetailID: number;
    orderID: any;
    invoiceID: any;
    orderInvoiceDate: any;
    transactionID: any;
    agency: any;
    advertiser: any;
    createdbY: any;
    amount: any;
    CreditManagerComments: any;
    action: Action;
    RefundApproved: any;
    approvalStatus: any;
    invalidAction: boolean;
    invalidComments: boolean;
    comments: string;
    refundApproved: any;
    updatedDate: any;
    updatedBy: any;
    selectedaction: any;
    submittedBy: any;
}

export interface Action {
    actionID: number;
    actionType: string;
}

export class refundApproveReport {
    orderID: any;
    invoiceID: any;
    invoiceDate: any;
    transactionID: any;
    agency: any;
    advertiser: any;
    submittedBy: any;
    amount: any;

}

export class refundSubmit {
    refundDetailID: number;
    refundApproved: boolean;
    approvalStatus: string;
    creditManagerComments: string;
    updatedDate: any;
    updatedBy: number;
}
export enum ApprovalStatus {
    Rejected = "Rejected",
    Approved = "Approved",
    Revised = "Revised"
}



// WEBPACK FOOTER //
// ./src/app/refund-approve/Model/refundApprove.ts